<template>
  <v-card>
    <v-card-title>Solicitação de Baixas</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <v-form>
              <validation-provider
                v-slot="{ errors }"
                :rules="{
                  required: true,
                }"
                name="terminal"
              >
                <v-select
                  v-model="form.terminal"
                  :items="terminais"
                  item-text="business_name"
                  item-value="public_id"
                  :error-messages="errors"
                  label="Terminal de Saída"
                ></v-select>
              </validation-provider>
            </v-form>
            <v-card-actions class="justify-end">
              <v-btn color="error" :disabled="invalid" @click="callback"
                >Chamar ({{ quantidade }})</v-btn
              >
            </v-card-actions>
          </validation-observer>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ModalChamarCaminhoes',

  props: {
    callback: {
      type: Function,
      required: true,
    },
    quantidade: {
      type: Number,
      required: true,
    },
    terminalSelecionado: {
      type: String,
      default: () => {
        return ''
      },
    },
  },

  data() {
    return {
      form: {
        terminal: '',
      },
    }
  },
  mounted() {
    this.selecionaTerminal()
  },
  watch: {
    terminalSelecionado(val) {
      if (val) {
        this.selecionaTerminal()
      }
    },
    'form.terminal'(novoValor) {
      this.$emit('update:terminalDestino', novoValor)
    },
  },
  computed: {
    ...mapState('solicitacaoBaixa', ['terminais']),
  },

  methods: {
    resetar() {
      if (this.form.terminal != this.terminalSelecionado) {
        this.form.terminal = ''
      }
    },
    selecionaTerminal() {
      if (
        this.terminais
          .map((i) => i.public_id)
          .includes(this.terminalSelecionado)
      ) {
        this.$nextTick(() => {
          this.form.terminal = this.terminalSelecionado
        })
      } else {
        const terminal = this.terminais.find(
          (i) => i.cliente_id == this.terminalSelecionado
        )
        if (terminal) {
          this.$nextTick(() => {
            this.form.terminal = terminal.public_id
          })
        }
      }
    },
  },
}
</script>
